import ReviewsPage from "./Reviews/ReviewsPage";
import ReviewDetail from "./Reviews/ReviewDetail";
import AttorneyProfile, { AdminAttorneys } from "./Reviews/AttorneyProfile";
import Notifications from "./Reviews/Notifications";
import React from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import { UserProvider } from "./Context/UserContext";
import { LanguageProvider } from "./Context/LanguageContext";
import { WorkproductProvider } from "./Context/WorkproductContext";
import Menu from "./Menu/Menu";
import LoginPage from "./Login/LogIn";
import SignUpPage from "./Login/SignUp";
import WorkWithUs from "./Login/WorkWithUs";
import { AccountRequests, AttorneyApplications } from "./Admin/AccountAdmin";
import { PortalProvider, PortalRoute } from "./Portal/PortalContext";
import EmailVerificationPage from "./OtherPages/EmailVerificationPage";
import PasswordResetPage from "./OtherPages/PasswordResetPage";
import RequestPasswordResetPage from "./OtherPages/RequestPasswordResetPage";
import { NotFoundPage } from "./OtherPages/NotFoundPage";
import AccountPage from "./Account/AccountPage";
import QuestionsPage from "./Questions/QuestionsPage";
import QuestionPage from "./Questions/QuestionPage";
import NewQuestion from "./Questions/NewQuestion";
import DocumentsPage from "./Documents/DocumentsPage";
import WorkproductPage from "./WorkProductPage/WorkproductPage";
import SharedWorkproductPage from "./OtherPages/SharedWorkproductPage";
import PublicHome from "./Public/PublicHome";
import PublicNotice from "./Public/PublicNotice";

export default function App() {
  return (
    <LanguageProvider>
      <UserProvider>
        <WorkproductProvider>
          <BrowserRouter>
            <PortalProvider>
              <Menu>
                <Routes>
                  <Route
                    element={
                      <PortalRoute allowed={["customer"]}>
                        <Outlet />
                      </PortalRoute>
                    }
                  >
                    <Route path="/questions" element={<QuestionsPage />} />
                    <Route path="/questions/new" element={<NewQuestion />} />
                    <Route path="/questions/:id" element={<QuestionPage />} />
                    <Route path="/documents" element={<DocumentsPage />} />
                    <Route
                      path="/workproducts/:workproductid"
                      element={<WorkproductPage />}
                    />
                    <Route path="/reviews" element={<QuestionsPage />} />
                    <Route path="/account" element={<AccountPage />} />
                  </Route>
                  {/* Attorneys now apply through the public Work with us page. */}
                  <Route
                    path="/attorney/apply"
                    element={<Navigate to="/work-with-us" replace />}
                  />
                  <Route
                    path="/reviews/:id"
                    element={
                      <PortalRoute allowed={["customer", "attorney"]} review>
                        <ReviewDetail />
                      </PortalRoute>
                    }
                  />
                  <Route
                    path="/attorney/reviews"
                    element={
                      <PortalRoute allowed={["attorney"]} approvedAttorney>
                        <ReviewsPage mode="attorney" />
                      </PortalRoute>
                    }
                  />
                  <Route
                    path="/attorney/profile"
                    element={
                      <PortalRoute allowed={["attorney"]}>
                        <AttorneyProfile />
                      </PortalRoute>
                    }
                  />
                  <Route
                    element={
                      <PortalRoute allowed={["admin"]}>
                        <Outlet />
                      </PortalRoute>
                    }
                  >
                    <Route
                      path="/admin/reviews"
                      element={<ReviewsPage mode="admin" />}
                    />
                    <Route
                      path="/admin/attorneys"
                      element={<AdminAttorneys />}
                    />
                    <Route
                      path="/admin/accounts"
                      element={<AccountRequests />}
                    />
                    <Route
                      path="/admin/applications"
                      element={<AttorneyApplications />}
                    />
                  </Route>
                  <Route
                    path="/notifications"
                    element={
                      <PortalRoute>
                        <Notifications />
                      </PortalRoute>
                    }
                  />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/signup" element={<SignUpPage />} />
                  <Route path="/work-with-us" element={<WorkWithUs />} />
                  <Route
                    path="/verifyemail"
                    element={<EmailVerificationPage />}
                  />
                  <Route
                    path="/requestpasswordreset"
                    element={<RequestPasswordResetPage />}
                  />
                  <Route
                    path="/resetpassword"
                    element={<PasswordResetPage />}
                  />
                  <Route
                    path="/shared/workproduct/:id"
                    element={<SharedWorkproductPage />}
                  />
                  <Route path="/" element={<PublicHome />} />
                  {[['privacy','privacy'], ['terms','terms'], ['beta','terms'], ['privilege','privilege']].map(([path,kind]) => <Route key={path} path={`/${path}`} element={<PublicNotice kind={kind} />} />)}
                  {[
                    "/home",
                    "/myworks",
                    "/allworks",
                    "/alllegalworks",
                    "/documentagent",
                  ].map(path => (
                    <Route
                      key={path}
                      path={path}
                      element={<Navigate to="/" replace />}
                    />
                  ))}
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </Menu>
            </PortalProvider>
          </BrowserRouter>
        </WorkproductProvider>
      </UserProvider>
    </LanguageProvider>
  );
}
